import React from "react";
import { Box, Skeleton, Stack } from "@mui/material";

export default function ProductsCardSkeleton() {
  return (
    <Stack
      sx={{
        width: { xs: "150px", md: "250px", xl: "350px" },
        height: { xs: "260px", md: "370px", xl: "470px" },
        alignItems: "center",
        position: "relative",
        padding: { xs: ".8rem", md: "1.5rem" },
      }}
    >
      {/* Image Skeleton */}
      <Skeleton
        variant="rectangular"
        sx={{
          width: { xs: "120px", md: "230px", xl: "290px" },
          height: { xs: "100px", md: "230px", xl: "290px" },
          borderRadius: "1.5rem",
        }}
      />

      {/* Text Skeletons */}
      <Stack sx={{ py: ".5rem", gap: ".5rem", width: "100%" }}>
        <Skeleton
          variant="text"
          sx={{ fontSize: "1rem", mx: "auto", width: "80%" }}
        />
        <Skeleton
          variant="text"
          sx={{ fontSize: ".8rem", mx: "auto", width: "90%" }}
        />
        <Skeleton
          variant="text"
          sx={{ fontSize: ".8rem", mx: "auto", width: "70%" }}
        />
      </Stack>

      {/* Price Button Skeleton */}
      <Skeleton
        variant="rectangular"
        sx={{
          width: "100%",
          height: "40px",
          borderRadius: "1rem",
          mt: "auto",
        }}
      />
    </Stack>
  );
}
